import IComponent from "components/commons/IComponent";
import "./Download.scoped.css";
import Button from "@material-ui/core/Button";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import "./PanelBase.scoped.css";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import slopeNoFormat from "utils/slopeNoFormat";

class Download extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      slopeList: {
        SelectnDLFeature: "",
      },
      filename: "",
    };
    // this.uploadFile = this.uploadFile.bind(this);
  }
  componentDidMount() {
    this.props.mapUICallback("DisaleAllWhenShowPanel");
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.currentDialogHeight != prevProps.currentDialogHeight) {
      let targetDIV = document.querySelector(
        ".DialogPanelWindow.PanelBase.DownloadPanelBase .editableGridCell > .MuiTextField-root > .MuiInputBase-multiline.MuiOutlinedInput-multiline"
      );
      targetDIV.style.height = `${this.props.currentDialogHeight - 150}px`;
    }
  }
  componentWillUnmount() {}
  getFeature(pFStr) {
    // console.log(pFStr);
    var upLimit = 200;
    var outfeatStr = "";
    var maxGets = 0;
    var mFLst = pFStr.toUpperCase().split("\n");
    console.log(mFLst);
    maxGets = mFLst.length;
    if (maxGets > upLimit) maxGets = upLimit;
    var isValidFeature;
    for (var i = 0; i < maxGets; i++) {
      var ft = mFLst[i].trim();
      if (ft != "") {
        isValidFeature = true;
        var ft = slopeNoFormat.FeatureNo13Char(ft);
        var mapSheet = parseInt(ft.substr(0, 2));
        if (mapSheet == 0 || mapSheet > 16)
          isValidFeature = eval(isValidFeature && false);
        var grid1 = ft.substr(2, 2);
        if (grid1 != "NE" && grid1 != "NW" && grid1 != "SE" && grid1 != "SW")
          isValidFeature = eval(isValidFeature && false);
        var grid2 = ft.substr(5, 1);
        if (grid2 != "A" && grid2 != "B" && grid2 != "C" && grid2 != "D")
          isValidFeature = eval(isValidFeature && false);
        var tp = ft.substr(7, 2);
        if (
          tp != "C " &&
          tp != "CR" &&
          tp != "F " &&
          tp != "FR" &&
          (tp != "R ") & (tp != "DT") & (tp != "ND") & (tp != "NS")
        )
          isValidFeature = eval(isValidFeature && false);
        var sn = parseInt(ft.substr(9, 4));
        if (sn == 0) isValidFeature = eval(isValidFeature && false);
        if (isValidFeature) {
          if (outfeatStr == "") outfeatStr = ft;
          else outfeatStr = outfeatStr + ";" + ft;
          /*add alternte feature name with/without wall part*/
          var chkDigit = ft.substr(7, 1);
          if (chkDigit == "C" || chkDigit == "F") {
            var altFeature = ft.substr(0, 2) + grid1 + "-" + grid2 + "/";
            switch (tp) {
              case "C ":
                altFeature = altFeature + "CR";
                break;
              case "CR":
                altFeature = altFeature + "C ";
                break;
              case "F ":
                altFeature = altFeature + "FR";
                break;
              case "FR":
                altFeature = altFeature + "F ";
                break;
            }
            altFeature = altFeature + ft.substr(9, 4);
            outfeatStr = outfeatStr + ";" + altFeature;
          }
        }
      }
    }
    return outfeatStr;
  }
  async ProcessDownload() {
    var featureCount = this.chkFeature(this.state.slopeList.SelectnDLFeature);
    console.log(featureCount);
    if (featureCount == 0)
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "No valid features found !",
        content: "No valid features found !",
        onDialogOk: () => {},
      });
    else {
      try {
        if (featureCount > 200)
          this.props.showDialog({
            isOpen: true,
            type: "error",
            title: "Only first 200 features will be retrieved !",
            content: "Only first 200 features will be retrieved !",
            onDialogOk: () => {},
          });

        this.props.showDialog({
          isOpen: true,
          title: "Loading",
          content: (
            <div>
              <span className="icn_loading" />
              Submit your feature nos, please wait...
            </div>
          ),
          onDialogCancel: () => {},
        });
        let url = this.$config.gpToolUrls.SelectnDLFeature;

        let srcV = this.state.slopeList.SelectnDLFeature.replace(
          /\r/g,
          ""
        ).trim();

        let FilteredV = this.getFeature(srcV);

        let params = { FeatureFromList: FilteredV };
        let options = {
          userProxy: this.$config.useEsriProxy,
        };
        let result = await geoprocessor.submitJob(
          url,
          params,
          undefined,
          options
        );
        // Get the result with either fetchResultData(), fetchResultImage(), or fetchResultMapImageLayer();

        let processR = await result.waitForJobCompletion();
        let Output_File = await processR.fetchResultData("Output_File");
        let No_of_records = await processR.fetchResultData("No_of_records");

        console.log(Output_File);
        console.log(No_of_records);
        this.props.showDialog({
          isOpen: true,
          title: "Download feature polygon by input text successfully",
          content: (
            <div>
              <div style={{ display: "flex" }}>
                {No_of_records.value > 0 ? (
                  <>
                    <p>download file: </p>
                    <p>&nbsp;</p>
                    <p>
                      <a href={Output_File.value.url} target="_blank">
                        feature file (zip)
                      </a>
                    </p>
                  </>
                ) : (
                  <p> No download file </p>
                )}
              </div>
              <p>
                No. of feature polygon: {No_of_records.value || "No record"}{" "}
              </p>
            </div>
          ),
          onDialogOk: () => {},
        });
      } catch (e) {
        this.props.showDialog({
          isOpen: true,
          type: "error",
          title: "Failed to submit your feature nos",
          content: "Error occurred when submiting your feature nos",
          jsxElement: e.toString(),
          onDialogOk: () => {},
        });
      }
    }
    // result.fetchResultData();
    // result.fetchResultImage();
    // result.fetchResultMapImageLayer();
  }

  chkFeature(pFStr) {
    var outCount = 0;
    let a = pFStr;
    if (pFStr.trim().length > 0) {
      a = pFStr + "\n";
    }
    var numberOfLineBreaks = (a.match(/\n/g) || []).length;
    outCount = numberOfLineBreaks;
    return outCount;
  }

  async handleFileChange(e) {
    let file = e.target.files[0];
    let content = await file.text();
    this.setState({
      filename: file.name,
      slopeList: { SelectnDLFeature: content },
    });
    return;
    // let reader = new FileReader();
    // reader.readAsText(file);
    // reader.onload = () => {
    //   console.log("reader.result", reader.result);
    // };
    // console.log("reader.result", file.name);
    // reader.onerror = () => {
    //   console.log("file error", reader.error);
    // };
  }

  render() {
    let { slopeList } = this.state;
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Download shapefile by text input</span>

          <div />
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={() => this.props.mapUICallback("hideAllPanel")}
          />
        </div>
        <div className="SubPanelContent PanelContent">
          <div className="">
            {/* <div className="spacer" /> */}
            <div>
              <div>
                Copy and paste the feature nos into the text box below. Use line
                breaks to separate feature nos. Max 200 features for each batch.
              </div>
              <div className="spacer" />

              <EditableDatagridCell
                cellInfo={{
                  colDef: {
                    field: "SelectnDLFeature",
                    dataType: "text",
                    multiline: true,
                    hint: "e.g. 7SW-C/FR 577",
                  },
                  row: slopeList,
                }}
                onChange={(field, value, values) => {
                  this.setState({
                    slopeList: {
                      ...slopeList,
                      [field]: value,
                    },
                  });
                }}
              />
            </div>
            <div className="spacer" />
            <div>
              <div />
              <div className="EqualWidthChildren">
                <div className="AlignCentre button">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      // this.SendMail();

                      if (!!slopeList.SelectnDLFeature) {
                        this.ProcessDownload();
                      } else {
                        this.props.showDialog({
                          isOpen: true,
                          type: "error",
                          title: "Please input your feature nos.",
                          content: "input your feature nos.",
                          onDialogOk: () => {},
                        });
                      }
                    }}
                  >
                    <span>OK</span>
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      // this.SendMail();
                      this.props.mapUICallback("hideAllPanel");
                      this.setState({});
                    }}
                  >
                    <span>Cancel</span>
                  </Button>
                  <label for="file-input">Choose file</label>
                  <input
                    id="file-input"
                    type="file"
                    // className="FileButton"
                    accept="text/plain"
                    // variant="outlined"
                    title="import from text file"
                    name="CHOOSE FILE"
                    onChange={this.handleFileChange.bind(this)}
                  />
                  {/* <span>Choose File</span> */}
                  {/* </input> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Download;
